import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import {
  transformRequestEditReturnProtectionProduct,
  transformRequestResetReturnProtectionProduct,
  transformResponseReturnProtectionProduct,
} from './transformers'

const useReturnProtectionProduct = ({ storeId, setToastInfo }) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(null)
  const [uploaderKey, setUploaderKey] = useState(0)

  const {
    data: product,
    loading: gettingProduct,
    error: productError,
    fetchData: getProduct,
  } = useFetch(configurationServices.getReturnProtectionProduct, {
    doInitialRequest: false,
    transformResponse: transformResponseReturnProtectionProduct,
  })

  const { fetchData: editProduct, loading: savingProduct } = useFetch(
    configurationServices.editReturnProtectionProduct,
    {
      doInitialRequest: false,
      transformRequest: transformRequestEditReturnProtectionProduct,
    }
  )

  const { fetchData: resetProduct, loading: resettingProduct } = useFetch(
    configurationServices.editReturnProtectionProduct,
    {
      doInitialRequest: false,
      transformRequest: transformRequestResetReturnProtectionProduct,
    }
  )

  useEffect(() => {
    getProduct({ storeId }, null, () => {})
  }, [getProduct, storeId])

  const title = draft?.title ?? product?.product_title
  const image = draft?.preview ?? product?.product_image_url
  const hasChanges = Boolean(draft)
  const isTitleEmpty = !title?.trim()
  const isBusy = gettingProduct || savingProduct || resettingProduct

  const discardDraft = () => {
    setDraft(null)
    setUploaderKey(previousKey => previousKey + 1)
  }

  const changeTitle = newTitle => setDraft(previousDraft => ({ ...previousDraft, title: newTitle }))

  const changeImage = file => {
    const reader = new FileReader()

    reader.onload = () => {
      setDraft(previousDraft => ({ ...previousDraft, file, preview: reader.result }))
    }

    reader.readAsDataURL(file)
  }

  const onSave = async () => {
    try {
      await editProduct({ storeId, title, image: draft.file })
      await getProduct({ storeId })
      discardDraft()
      setToastInfo({ show: true, type: 'success', message: t('Cambios guardados') })
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  const onResetToDefault = async () => {
    try {
      await resetProduct({ storeId })
      await getProduct({ storeId })
      discardDraft()
      setToastInfo({ show: true, type: 'success', message: t('Cambios guardados') })
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  return {
    product,
    productError,
    isBusy,
    savingProduct,
    resettingProduct,
    title,
    image,
    hasChanges,
    isTitleEmpty,
    uploaderKey,
    changeTitle,
    changeImage,
    revertChanges: discardDraft,
    onSave,
    onResetToDefault,
  }
}

export default useReturnProtectionProduct
